var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[(_vm.userProfile && _vm.userProfile.is_superuser)?_c('v-btn',{staticClass:"v-btn--admin",attrs:{"fab":"","large":"","dark":"","bottom":"","left":"","to":{ name: 'admin' }}},[_c('v-icon',[_vm._v("admin_panel_settings")])],1):_vm._e(),_c('UserProfile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }